import { PageTitle, SelectAccountSplash } from '@joyful/ui/app'
import { useSetActiveAccount } from '@/features/auth/hooks/useSetActiveAccount'
import { safeDecodeUriComponent } from '@joyful/utils'
import { createSerializer, parseAsString, useQueryStates } from 'nuqs'

const SelectAccountRouteQueryMap = {
  redirect: parseAsString,
}

export const serializeSelectAccountQueryParams = createSerializer(
  SelectAccountRouteQueryMap,
)

export function SelectAccountRoute() {
  const [queryParams] = useQueryStates(SelectAccountRouteQueryMap)
  const setActiveAccount = useSetActiveAccount()

  return (
    <>
      <PageTitle>{`Select account`}</PageTitle>
      <SelectAccountSplash
        isPending={setActiveAccount.isPending}
        onSelectAccount={(account) => {
          const targetPath = queryParams.redirect
            ? safeDecodeUriComponent(queryParams.redirect)
            : undefined

          setActiveAccount.mutate({
            account,
            targetPath,
          })
        }}
      />
    </>
  )
}
